import { cn } from '@/lib/utils';

/**
 * Tailwind classes per priority level, ported from the omecare-mockups
 * priority badge: P1 = solid brand, P2 = secondary, P3+ = dashed muted.
 */
const PRIORITY_TONE: Record<number, string> = {
  1: 'bg-primary text-primary-foreground border-transparent',
  2: 'bg-secondary text-secondary-foreground border-transparent',
  3: 'border-dashed bg-transparent text-muted-foreground',
};

const FALLBACK_PRIORITY_TONE =
  'border-dashed bg-transparent text-muted-foreground';

/**
 * Compact priority badge rendered as `P{n}` with a tone that emphasises
 * higher priorities. Shared across doctor lists, booking forms and slot sheets.
 *
 * @param props.priority - the numeric priority level (1 = highest)
 * @param props.className - extra classes merged on the badge
 * @returns the priority badge element
 */
export const PriorityBadge = ({
  priority,
  className,
}: {
  priority: number;
  className?: string;
}) => {
  return (
    <span
      className={cn(
        'inline-flex h-[22px] min-w-[28px] items-center justify-center rounded-md border px-1.5 font-semibold text-[11px] tabular-nums',
        PRIORITY_TONE[priority] ?? FALLBACK_PRIORITY_TONE,
        className,
      )}
    >
      P{priority}
    </span>
  );
};
